import {Entity} from '../../core/commons/entity';

/**
 * Created by Lauta on 09/10/2017.
 */
export class DocumentCategory implements Entity {
    id: number;
    name: string;
    visible: boolean;
    parentCategory: DocumentCategory;

    constructor(value: Object = {}) {
        Object.assign(this, value);
    }

    public getBreadCrumb() : DocumentCategory[] {
        if ( this.parentCategory ){
            const breadcrumb =  this.parentCategory.getBreadCrumb();
            breadcrumb.push(this);
            return breadcrumb;
        }
        return [this];
    }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/domain/documentCategory.ts